// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dugtrio: PokeData = {
  "id": 51,
  "name": "dugtrio",
  "height": 7,
  "weight": 333,
  "base_experience": 149,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "scratch",
    "sand-attack",
    "growl",
    "earthquake",
    "fissure",
    "dig",
    "agility",
    "screech",
    "fury-swipes",
    "tri-attack",
    "slash",
    "mud-slap",
    "sandstorm",
    "magnitude",
    "astonish",
    "sand-tomb",
    "sucker-punch",
    "night-slash",
    "earth-power",
    "mud-bomb",
    "bulldoze",
    "rototiller"
  ],
  "moves": [
    "scratch",
    "growl",
    "earthquake",
    "fissure",
    "tri-attack",
    "mud-slap",
    "sandstorm",
    "magnitude",
    "night-slash",
    "earth-power",
    "mud-bomb",
    "rototiller",
    "mud-shot"
  ],
  "evolution_chain": {
    "id": 21,
    "item": null,
    "species": [
      {
        "name": "diglett",
        "order": 55,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dugtrio",
        "order": 56,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 50,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 71,
    "speed": 179,
    "ability_power": 150
  },
  "stat_changes": [],
  "catch_rate": 50,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
